import Loadable from 'react-loadable';
import Loader from '../../components/UIComponents/Loader';

export const LoadableWaveCharacteristics = Loadable({
  loader: () => import('./WaveCharacteristics'),
  loading: Loader
});
